import React from 'react'
import Navbar from '../components/Navbar'
import Brands from '../components/Brands'

const Sale = () => {
  return (
    <>
    <Navbar/>
    <div className='pt-8'>
      <Brands/>
      </div>
    </>
  )
}

export default Sale
